import styled from '@emotion/styled';
import { fontSize, ContentWrapper } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';
import IconBack from '@assets/images/icons/back.svg';

export const Wrapper = styled.div`
  width: 100%;
  background-color: #f7f7f8;
  padding: 72px 0;

  @media only screen and ${breakpoint.lg} {
    padding: 48px 0;
  }
`;
export const Container = styled(ContentWrapper)`
  display: flex;
  justify-content: space-between;
  grid-column-gap: 40px;
  z-index: 990;

  @media only screen and ${breakpoint.lg} {
    flex-direction: column;
  }
`;
export const Col1 = styled.div`
  max-width: 530px;
  .link-back {
    text-transform: uppercase;
    text-decoration: none;
    font-size: 24px;
    line-height: 1.5;
    letter-spacing: -0.36px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.link.primary};
    background: url(${IconBack.src}) no-repeat left -4px top 50%;
    padding-left: 45px;
    &:hover {
      text-decoration: underline;
    }
  }
  img {
    width: 100%;
  }

  @media only screen and ${breakpoint.lg} {
    max-width: unset;
  }
`;
export const Col2 = styled.div`
  flex: 0 0 43%;
  position: relative;

  .link-edit {
    position: absolute;
    top: -40px;
    right: 0;
    display: block;
    text-align: right;
    color: ${({ theme }) => theme.colors.link.primary};
    font-size: ${({ theme }) => theme.sizes.button.fontSize.medium}px;
    &:hover {
      text-decoration: none;
    }
  }

  @media only screen and ${breakpoint.lg} {
    margin-top: 30px;
  }
`;
export const OfferName = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.67;
  letter-spacing: -0.27px;
  color: #00405b;
  margin-top: 52px;
`;
export const OffeExpirationDate = styled.div`
  font-size: 12px;
  font-weight: normal;
  line-height: 2.5;
  letter-spacing: -0.18px;
  color: #004660;
  margin-top: 10px;
  margin-bottom: 16px;
`;

export const OfferDescription = styled.div`
  margin-top: 16px;
  margin-bottom: 32px;
  text-align: justify;

  ul,
  ol,
  .offer-ul {
    margin-top: 15px;
    margin-bottom: 40px;

    li {
      display: flex;
      align-items: flex-start;
      padding: 8px 0 8px 14px;
      position: relative;

      &::before {
        position: absolute;
        left: 0;
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #e6007e;
        margin: 10px 10px 0 0;
      }
    }
  }
`;

export const ApplySectionWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 32px 0 24px;
`;

export const OfferContent = styled.div`
  p,
  div,
  li {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5;
    letter-spacing: -0.24px;
    color: #00202d;
  }

  .subtitle {
    font-weight: 500;
    display: block;
    margin-bottom: 15px;
  }

  .offer-type {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.link.primary};
    margin-bottom: 36px;
    text-transform: uppercase;
  }
  .offer-author {
    a {
      color: ${({ theme }) => theme.colors.link.primary};
      font-size: ${({ theme }) => theme.sizes.button.fontSize.medium}px;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
    &--contact {
      margin-top: 4px;
      line-height: 2.5;
    }
  }
`;

export const Section = styled.div`
  & + & {
    margin-top: 32px;
  }

  strong {
    font-size: ${fontSize(16)};
    line-height: 1.5;
    font-weight: bold;
    letter-spacing: -0.24px;
    color: #00202d;
    display: inline-block;
  }
`;

export const WYSWIGContent = styled.div`
  h1 {
    font-size: 22px;
    line-height: 28px;
    font-weight: bold;
  }

  h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: bold;
  }

  text-align: justify;

  ul,
  ol,
  .offer-ul {
    margin-top: 15px;
    margin-bottom: 40px;

    li {
      display: flex;
      align-items: flex-start;
      padding: 8px 0 8px 14px;
      position: relative;

      &::before {
        position: absolute;
        left: 0;
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #e6007e;
        margin: 10px 10px 0 0;
      }
    }
  }
`;
